import React from "react";
import LeadsTableBody from "./LeadsTableBody";

/**
 * Wrapper for rendering Job Leads rows.
 * Reuses the shared `LeadsTableBody` but sets `activeTab="Job Leads"`.
 */
function JobLeadsTable(props) {
  return <LeadsTableBody {...props} activeTab="Job Leads" />;
}

export default JobLeadsTable;

